<app-nav-bar></app-nav-bar>

<div class="container"></div>
<router-outlet></router-outlet>

<app-footer></app-footer>
